<template>
  <div class="div_base">
    <div class="module">
      <Header :navIndex="1"/>
      <!--:tabBarStyle="{ color: 'white', padding: '10px',textAlign: 'center', borderBottom: 'unset' }"  @change="tabCallback2" -->
      <a-tabs ref="myTabs" :default-active-key="baseKey" v-model="baseKey" @change="tabCallback"
              tab-position="left" class="custom_tab" :tabBarStyle="{ color: 'red', border: 0 }">
        <a-tab-pane key="8" class="hide-divider">
           <span slot="tab" class="custom_tab_panel_title">
             <img :src="serviceSelected" width="20" v-if="baseKey === '8'">
             <img :src="serviceUnSelected" width="20" v-else>
             <span class="custom_tab_panel_title" :class="{'ant-tabs-tab-active':baseKey === '8'}">服务信息管理</span>
           </span>
          <div class="serviceInfoManage">
            <a-row>
              <a-row class="text_tip" style="font-size: 16px;color: rgb(207, 208, 211);text-align: left;margin: 10px 5px 5px 0;">
                以下信息由您的知识库总结而成，若与您的信息不符或缺失，请修改知识库相关模块内容后重新提交。
              </a-row>
              <a-spin v-if="loadingCheck" size="large" style="position: absolute;left: 50%;top: 50%;transform: translateX(-50%)" />
              <a-textarea ref="bt0" class="custom_textarea" :placeholder="textDemo" :rows="20" v-model="fileContentFull" :disabled="true">
              </a-textarea>
            </a-row>

            <a-row style="text-align: left">
              <span style="color: #28E04A;font-size: 12px;" @click="showServiceGuide"> 服务信息填写指南 </span><br/>
            </a-row>

            <!--知识库总结刷新按钮-->
            <a-row style="margin: 50px 0 10px 0">
              <a-button type="primary" @click="refreshFullContent()" class="btn_query_project btn_now" style="color: black;width: 120px;"
                        :loading="confirmLoading" >刷 新</a-button>
            </a-row>
            <a-row style="color: #999999;font-size: 12px;margin-bottom: 35px">
              录入知识库后点击刷新生成您的营销信息
            </a-row>
          </div>
        </a-tab-pane>

        <a-tab-pane key="1" :forceRender="true" class="hide-divider">
          <span slot="tab" class="custom_tab_panel_title" @click.stop="clickStop(1)">
            <span class="tab_title_mini">个人及企业信息</span>
          </span>
          <div class="serviceInfoManage">
            <BaseTextArea :activityKey="baseKey" ref="bt1" :baseContent="baseContentJson.personal_info_json"
                          @jieSaveBase="jieSaveBase" @showLoginPanel="showLoginPanel" @jieCheckSelfBase="jieCheckSelfBase"/>
          </div>
        </a-tab-pane>

        <a-tab-pane key="2" :forceRender="true" class="hide-divider">
          <span slot="tab" class="custom_tab_panel_title" @click.stop="clickStop(2)">
            <span class="tab_title_mini">产品/服务价值及优势</span>
          </span>
          <div class="serviceInfoManage">
            <BaseTextArea :activityKey="baseKey" ref="bt2" :baseContent="baseContentJson.product_overview_json"
                          @jieSaveBase="jieSaveBase" @showLoginPanel="showLoginPanel" @jieCheckSelfBase="jieCheckSelfBase"/>
          </div>
        </a-tab-pane>

        <a-tab-pane key="3" :forceRender="true" class="hide-divider">
          <span slot="tab" class="custom_tab_panel_title" @click.stop="clickStop(3)">
            <span class="tab_title_mini">用户画像及案例</span>
          </span>
          <div class="serviceInfoManage">
            <BaseTextArea :activityKey="baseKey" ref="bt3" :baseContent="baseContentJson.people_portrait_json"
                          @jieSaveBase="jieSaveBase" @showLoginPanel="showLoginPanel" @jieCheckSelfBase="jieCheckSelfBase"/>
          </div>

        </a-tab-pane>

        <a-tab-pane key="4" :forceRender="true" class="hide-divider" v-if="false">
          <span slot="tab" class="custom_tab_panel_title" @click.stop="clickStop(4)">
            <span class="tab_title_mini">购买方式及注意事项</span>
          </span>
          <div class="serviceInfoManage">
            <BaseTextArea :activityKey="baseKey" ref="bt4" :baseContent="baseContentJson.purchase_method_json"
                          @jieSaveBase="jieSaveBase" @showLoginPanel="showLoginPanel" @jieCheckSelfBase="jieCheckSelfBase"/>
          </div>
        </a-tab-pane>

        <a-tab-pane key="5" :forceRender="true" class="hide-divider" v-if="false">
          <span slot="tab" class="custom_tab_panel_title" @click.stop="clickStop(5)">
            <span class="tab_title_mini">售后服务</span>
          </span>
          <div class="serviceInfoManage">
            <BaseTextArea :activityKey="baseKey" ref="bt5" :baseContent="baseContentJson.sale_service_json"
                          @jieSaveBase="jieSaveBase" @showLoginPanel="showLoginPanel" @jieCheckSelfBase="jieCheckSelfBase"/>
          </div>
        </a-tab-pane>

        <a-tab-pane key="6" :forceRender="true" class="hide-divider">
          <span slot="tab" class="custom_tab_panel_title" @click.stop="clickStop(6)">
            <span class="tab_title_mini">其他</span>
          </span>
          <div class="serviceInfoManage">
            <BaseTextArea :activityKey="baseKey" ref="bt6" :baseContent="baseContentJson.other_info_json"
                          @jieSaveBase="jieSaveBase" @showLoginPanel="showLoginPanel" @jieCheckSelfBase="jieCheckSelfBase"/>
          </div>
        </a-tab-pane>

        <a-tab-pane key="7" class="hide-divider" v-if="false">
          <span slot="tab" class="custom_tab_panel_title">
            <span class="tab_title_mini">文件上传</span>
          </span>
          <div class="serviceInfoManage" style="position: relative;">
            <a-row>
              <a-row class="text_tip" style="font-size: 16px;color: rgb(207, 208, 211);text-align: left;margin: 10px 5px 5px 0;">
                为快速构建您的知识库。您可以直接上传按的知识库文件。
              </a-row>
              <div >
<!--                文件列表 实质只显示一个文件-->
              </div>
            </a-row>
            <a-row style="text-align: left">
              <!--4.请先<a id="downloadText" style="color: #28E04A;" href="https://test.aigcpop.com/agent_file/article_example.txt">下载知识库模板</a>后编辑提交，编辑时请勿删除 "##"所在行内容-->
              <span style="color: #28E04A;font-size: 12px;" @click="showServiceGuide"> 服务信息填写指南 </span><br/>
              <span  style="font-size: 12px;font-weight: 400;color: rgba(255,255,255,0.8);line-height: 12px;">
                注:1.文件上传方式编辑知识库为全量覆盖更新，因此请确保您上传文件内容是完整的最新内容!<br/>
                2.上传文档数量仅支持1个，格式支持txt、word. pdf文档。<br/>
                3.最多支持十万字，文件大小约30Ok。<br/>
              </span>
            </a-row>
            <a-row type="flex" style="margin: 38px 20px 8px 0">
              <a-col flex="1" style="text-align: left">
                <a-button class="btn_upload" @click="showLoginPanel" v-if="!$store.state.userAuth.haveLogin"> 尚未登录 </a-button>
                <a-upload  v-if="$store.state.userAuth.haveLogin"
                           name="file"
                           :multiple="false"
                           listType="text"
                           :file-list="fileList"
                           @change="handleFileChange"
                           :before-upload="handleBeforeUpload"
                           accept=".text,.txt"
                           :custom-request="customUpload"
                >
                  <a-button class="btn_upload"> 上传 (步骤1) </a-button>
                </a-upload>
              </a-col>
              <a-col flex="1" style="text-align: right">
                <a-button type="primary" class="btn_now"  @click="uploadFileBefore">
                  提交 (步骤2)
                </a-button>
              </a-col>
            </a-row>
          </div>

        </a-tab-pane>

        <a-tab-pane key="0" class="hide-divider">
          <span slot="tab" class="custom_tab_panel_title">
            <img :src="infoSelected" v-if="baseKey === '0'" width="20">
            <img :src="infoUnSelected" width="20" v-else> 产品管理</span>
          <div v-if="$store.state.userInfo.mall_state === 3" class="productManage" style="padding-top: 100px">
            <a-result class="myResult">
              <template #icon>
                <img src="@/assets/icon_gou.png" width="64" height="64">
              </template>
              <template #extra>
                <div style="color:#67d961;font-size: 18px;">恭喜您成功入驻商城！您可以在‘我的商城’模块，轻松管理您的商品啦。祝您生意兴隆！</div>
              </template>
            </a-result>
          </div>
          <div v-if="mallState === -1" class="productManage" style="padding-top: 100px">
            <a-result class="myResult">
              <template #icon>
                <img src="@/assets/icon_gou.png" width="64" height="64">
              </template>
              <template #extra>
                <div style="color:#67d961;font-size: 18px;">尚未登录</div>
              </template>
            </a-result>
          </div>
          <div v-if="mallState === 4" class="productManage" style="padding-top: 100px">
            <a-result class="myResult">
              <template #icon>
                <img src="@/assets/icon_gou.png" width="64" height="64">
              </template>
              <template #extra>
                <div style="color:#67d961;font-size: 18px;">帮卖用户暂不支持商品/商城功能</div>
              </template>
            </a-result>
          </div>
          <div v-if="mallState === 0 || mallState === 1 || mallState === 2" class="productManage">
            <a-row class="headerRow" type="flex">
              <a-col :span="18" align="start">
                <div class="project_name" style="margin-right: 5px;font-weight: 400">产品名称</div>
                <a-input class="input_project_custom project_item" v-model="productName" placeholder="请输入产品名称" style="text-align: left"></a-input>
                <a-button class="btn_query_project project_item" type="primary"  @click="queryProduct">查询</a-button>
                <a-button class="btn_reset_project project_item"  @click="queryReset">重置{{$store.state.userInfo.mall_state}}</a-button>
                <a-popconfirm placement="bottom" ok-text="Yes" cancel-text="No" @confirm="deleteListSure">
                  <template slot="title">
                    <p> 确认删除这 {{ selectedList.length }} 条数据吗</p>
                  </template>
                  <a-button class="btn_reset_project project_item" v-if="showDelete">删除</a-button>
                </a-popconfirm>

              </a-col>
              <a-col :span="6" align="end">
                <a-button class="btn_add_project project_item" type="primary" style="color: black;margin-right: 0" @click="addProduct">
                  <a-icon type="plus" style="font-size: 18px;"/><span style="margin-left: 0">添加产品</span>
                </a-button>
              </a-col>
            </a-row>
            <a-row>
              <a-table class="product_table"
                       :locale="{emptyText: '暂无数据'}"
                       :columns="columns"
                       :data-source="testList"
                       :row-key="getRowKey"
                       :pagination="paginationConfig"
                       :row-selection="rowSelection"
              >
                <a slot="name" slot-scope="text">{{ text }}</a>
                 <span slot="action" slot-scope="text, record">
                    <a-popconfirm
                      title='确定删除吗?'
                      @confirm='() => onDelete(record)'
                    >
                       <a href="javascript:;"><a class="product_option">删除</a></a>
                   </a-popconfirm>
                    <a class="product_option" @click="onEdit(record)">编辑</a>
                   <a class="product_option" @click="checkSelfPD(record)">AI自查</a>
                <!--<a class="product_option">取消爆品</a>-->
                </span>
              </a-table>
            </a-row>
          </div>
        </a-tab-pane>
      </a-tabs>

      <!--新增商品和编辑商品的modal-->
      <a-modal
        :visible="modalVisible"
        :confirm-loading="confirmLoading"
        ok-text='保存'
        cancel-text=''
        @ok="jieHandleOk"
        @cancel="handleCancel"
        :closable="true"
        :maskClosable="true"
        class="productModal"
      >
        <template #footer>
          <div style="text-align: center">
            <a-button type="primary" @click="jieHandleOk()" class="btn_query_project btn_now" style="color: black;width: 120px;"
                      :loading="confirmLoading">保存</a-button>
          </div>
        </template>
        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品名称：</a-row>
        <a-row class="product_modal_row">
          <a-input class="input_project_custom project_item" v-model="productItem.name" placeholder="请输入产品名称"/>
          <a-row class="errorInputText" v-if="warnInfo.showName"> {{warnInfo.showNameMsg}} </a-row>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品价格：</a-row>
        <a-row class="product_modal_row">
          <a-input class="input_project_custom project_item" v-model="productItem.price" placeholder="请输入产品价格"/>
          <a-row class="errorInputText" v-if="warnInfo.showPrice">{{warnInfo.showPriceMsg}}</a-row>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品介绍：</a-row>
        <a-row class="product_modal_row">
          <a-textarea class="input_project_custom"
                      v-model="productItem.description"
                      placeholder="请输入产品介绍"
                      :auto-size="{ minRows: 2, maxRows: 2 }"
          />
          <a-row class="errorInputText" v-if="warnInfo.showDescription"> {{warnInfo.showDescriptionMsg}} </a-row>
        </a-row>

        <a-row class="product_modal_title_row" v-if="false">产品链接：</a-row>
        <a-row class="product_modal_row" v-if="false">
          <a-input class="input_project_custom project_item" v-model="productItem.url" placeholder="请输入产品链接"/>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>引导文案：</a-row>
        <a-row class="product_modal_row">
          <a-input class="input_project_custom project_item" v-model="productItem.comm_tip" placeholder="请输入引导文案"/>
          <a-row class="errorInputText" v-if="warnInfo.showCommTip"> {{warnInfo.showCommTipMsg}} </a-row>
        </a-row>

        <a-row class="product_modal_title_row"><span class="warnInfo">*</span>产品图片（1~10张）：</a-row>
        <a-row class="product_modal_row">

          <a-upload
            :custom-request="handleCustomRequest"
            :headers="requestHeaders"
            list-type="picture-card"
            :file-list="imageList"
            @change="handleImageChange"
            @preview="handlePreview"
            :before-upload="handleBeforeUploadImage"
            accept=".jpg,.png,.jpeg"
          >
            <div v-if="imageList.length < 10">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
          <a-row class="errorInputText" v-if="warnInfo.showImage"> {{warnInfo.showImageMsg}} </a-row>
           <a-modal :visible="previewVisible" :footer="null" @cancel="handleImageCancel">
            <img alt="example" style="width: 100%" :src="previewImageSrc" />
          </a-modal>
        </a-row>

        <a-row class="product_modal_title_row">产品视频（1）：</a-row>
        <a-row class="product_modal_row">
          <a-upload
            :custom-request="handleCustomRequestVideo"
            :headers="requestHeaders"
            list-type="picture-card"
            :file-list="videoList"
            @change="handleVideoChange"
            @preview="handlePreviewVideo"
            :before-upload="handleBeforeUploadVideo"
            accept=".mp4,.avi,.wmv,.mov,.webm,.3gp"
          >
            <div v-if="videoList.length < 1">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                上传
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisibleVideo" :footer="null" @cancel="handleVideoCancel">
            <div ref="videoContainer" style="position: relative;height: 70%; overflow: hidden;display: flex;justify-content: center">
              <a-icon type="play-circle" color="#8e867e" class="icon_play_video" style="font-size: 64px;position: absolute;left: 50%;top: 50%;opacity: 0.5;transform: translate(-50%, -50%);"
                      @click.self="playPdVideo" v-if="!productPlaying"/>
              <video ref="pdVideo" :src="previewVideoSrc" style="width: 70%; height: 70%;"
                     muted
                     loop
                     :autoplay="false"
                     :controls="true"
                     playsinline="true"
                     :poster="previewVideoSrc + '?x-oss-process=video/snapshot,t_1,m_fast,f_png'"
                     @play="onPDVideoPlaying"
                     @click="playPdVideo"
                     @loadedmetadata="setVideoSize"
                     @ended="productPlaying = false"
              >
              </video>
            </div>
          </a-modal>
        </a-row>
      </a-modal>

      <!--提交知识库的确认弹窗-->
      <a-modal :centered="true" v-model="openBaseSubmitDialog" class="base_submit_dialog" @ok="uploadFile" cancelText="取消" okText="提交覆盖">
        <div class="base_submit_dialog_content">App端已更新为模块化录入方式，若您在App上进行了模块编辑，通过PC端提交将覆盖这些更改。请确认是否继续提交，或回到App端重新检查内容。</div>
      </a-modal>
      <!--切换知识库填写框的确认弹窗-->
      <a-modal :centered="true" v-model="isShowChangeTextDialog" title="请注意保存内容" class="base_feedback_dialog">
        <template slot="footer" style="text-align: center" class="base_feedback_dialog_footer">
          <div>
            <a-button key="cancel" @click="textChangeDialogCancel" >
              否
            </a-button>
            <a-button type="primary" key="save" @click="dialogSave" style="background: rgb(17, 159, 250) !important;border-color:rgb(17, 159, 250) !important;">
              是
            </a-button>
          </div>

        </template>

        <span> 该模块内容尚未保存，是否现在保存?</span>
      </a-modal>

      <!--产品AI自查-->
      <a-modal :centered="true" v-model="checkPDDialogVisible" title="AI自查结果" class="base_feedback_dialog">
        <template slot="footer" style="text-align: center" class="base_feedback_dialog_footer">
          <div style="text-align: center">
            <a-button type="primary" key="cancel" @click="checkPDDialogVisible = false" style="background: rgb(17, 159, 250) !important;border-color:rgb(17, 159, 250) !important;">
              知道了
            </a-button>
          </div>

        </template>
        <a-spin size="large" v-if="loadingPDFeedback" style="width: 100%"/>
        <span v-if="!loadingPDFeedback"> {{checkPDResult}} </span>
      </a-modal>
      <!--底部版权声明-->
      <Footer style="position: relative !important;"/>
    </div>
<!--    <a-modal :visible="modalVisible" @cancel="handleCancel" :footer="null">

    </a-modal>-->
  </div>
</template>

<script>
import Footer from './Footer.vue'
import Header from './Header.vue'
import axios from 'axios'
import store from '../store/store'
import { mapState } from 'vuex'
import BaseTextArea from './mini/BaseTextArea.vue'
import _ from 'lodash'

export default {
  name: 'Base',
  components: {Header, Footer, BaseTextArea},
  computed: {
    ...mapState(['userAuth', 'project0']),
    showDelete () {
      return this.selectedList.length > 0
    },
    projectId () {
      return this.project0.id
    },
    mallState () {
      return this.$store.state.userInfo.mall_state
    }
  },
  props: [],
  inject: ['showLogin'],
  watch: {
    userAuth (newValue, oldValue) {
      // 监听 message 数据的变化
      // console.log('New value:', newValue);
      if (!newValue.haveLogin) {
        this.clearList()
      } else {
        this.selectAllProduct()
        this.getArticle()
      }
    },
    projectId (newValue) {
      // 监听 message 数据的变化
      // console.log('projectId New value:', newValue)
      if (newValue > -1) {
        if (this.$store.state.userAuth.haveLogin) {
          this.getArticle()
          this.selectAllProduct()
        }
      } else {
        this.fileContent = ''
      }
    }
  },
  data () {
    return {
      loadingCheck: false,
      serviceSelected: require('@/assets/icon/service_manager_selected.png'),
      serviceUnSelected: require('@/assets/icon/service_manager_unselected.png'),
      infoSelected: require('@/assets/icon/info_manager_selected.png'),
      infoUnSelected: require('@/assets/icon/info_manager_unselected.png'),
      fileList: [
      ],
      fileContent: '',
      fileContentFull: localStorage.getItem('fileContentFull') ? JSON.parse(localStorage.getItem('fileContentFull')) : '',
      baseContentJson: {
        personal_info_json: {'score': 0, 'text': ''},
        people_portrait_json: {'score': 0, 'text': ''},
        product_overview_json: {'score': 0, 'text': ''},
        purchase_method_json: {'score': 0, 'text': ''},
        sale_service_json: {'score': 0, 'text': ''},
        other_info_json: {'score': 0, 'text': ''}
      },
      baseTip: '想象AI智能体是你新入职的员工或助理。你需要向他们提供公司的基本信息，如业务内容、优势和销售产品，以及必要的行业和专业知识。\n' +
        '记住，信息越全面，你的AI智能体表述就越准确。不必担心格式，保证信息完整且不冲突即可。如果不能一次填写全面也不必焦虑，你可以随时补充和修改。填写过程中也可参考屏幕左上角的指南获取灵感，也可在录入行业信息等内容后点击右上角【AI诊断】按钮针对已录入内容进行分析获得调整建议。\n' +
        '现在就开始，让你的AI智能体活起来吧！！',
      textDemo: '我的人设是:\n' +
        'xxxxxxxxx' +
        '\n' +
        '\n' +
        '我的产品和服务:\n' +
        'xxxxxxxxx' +
        '\n' +
        '\n' +
        '我的用户画像是:\n' +
        'xxxxxxxxx' +
        '\n' +
        '\n' +
        '我给用户传递的价值:\n' +
        'xxxxxxxxx' +
        '\n' +
        '\n' +
        '用户的购买理由:\n' +
        'xxxxxxxxx' +
        '\n' +
        '\n' +
        '成功案例:\n' +
        '缺失' +
        '\n' +
        '\n',
      productName: '',
      testList: [],
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          key: 'index',
          customRender: this.renderIndex,
          width: 50,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: '产品名称',
          dataIndex: 'name'
        },
        {
          title: '价格',
          dataIndex: 'price'
        },
        {
          title: '产品介绍',
          dataIndex: 'description',
          customRender: this.renderDescription
        },
        {
          title: '产品链接',
          dataIndex: 'url',
          customRender: this.renderDescription
        },
        {
          title: '引导文案',
          dataIndex: 'comm_tip',
          customRender: this.renderDescription
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      modalVisible: false,
      showServiceGuideModal: false,
      confirmLoading: false,
      paginationConfig: {
        pageSize: 10
      },
      productDesc: '',
      productItem: {},
      productTemplate: {
        'comm_tip': '',
        'text': '',
        'cover_store_path': '',
        'cover_url': '', // 获取是cover字段
        'cover_urls': [], // 多个图片
        'cover': '', // 提交是cover字段
        'custom_ids': [], // 引导文案
        'description': '',
        'name': '',
        'price': '',
        'project': this.$store.state.project0.id,
        'project_id': this.$store.state.project0.id,
        'url': '',
        'video_urls': []
      },
      imageList: [], // 产品图片列表
      requestHeaders: {authorization: this.$store.state.userAuth.userToken},
      imageUploadAction: this.$store.state.apiHost + '/api/user/upload_file?file_type=1',
      videoUploadAction: this.$store.state.apiHost + '/api/user/upload_file?file_type=5',
      previewVisible: false,
      previewVisibleVideo: false,
      previewImageSrc: '',
      previewVideoSrc: '',
      warnInfo: {
        showName: false,
        showNameMsg: '请输入产品名称',
        showPrice: false,
        showPriceMsg: '请输入产品价格',
        showDescription: false,
        showDescriptionMsg: '请输入产品介绍',
        showCommTip: false,
        showCommTipMsg: '请输入引导文案',
        showImage: false,
        showImageMsg: '请上传产品图片/视频'
      },
      submitType: 1,
      selectedList: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          this.selectedList = selectedRows // 将选中的行数据赋值给selectedList
        }
      },
      loadingBase: false, // 知识库加载状态 默认不加载
      openBaseSubmitDialog: false,
      baseKey: '8',
      isShowChangeTextDialog: false,
      wantTabKey: '1',
      // 产品AI自查弹框
      checkPDResult: '',
      loadingPDFeedback: true,
      checkPDDialogVisible: false,
      // 视频上传
      videoList: [],
      productPlaying: false
    }
  },
  created () {
    console.log('base created', this.$store.state.isMobile)
    if (this.$store.state.isMobile) {
      this.$router.push('/m/base')
    }
  },
  beforeDestroy () {
    // 移除事件监听以避免内存泄漏
    window.removeEventListener('keydown', this.handleKeyDown)
  },
  mounted () {
    // 监听键盘按下事件
    window.addEventListener('keydown', this.handleKeyDown)
    this.productItem = JSON.parse(JSON.stringify(this.productTemplate)) // Object.assign({}, this.productTemplate)
    this.selectAllProduct()
    this.getArticle()
  },
  methods: {
    clickStop (value) {
      let preventModel = String(this.baseKey)

      let keyInt = parseInt(this.baseKey)
      if (keyInt > 0 && keyInt < 7) {
        const refName = 'bt' + this.baseKey
        let isChangeText = this.$refs[refName].getIsChangeText()
        if (isChangeText) {
          this.wantTabKey = String(value)
          this.isShowChangeTextDialog = true
          this.baseKey = preventModel
        } else {
          this.baseKey = String(value)
        }
      } else {
        this.baseKey = String(value)
      }
    },
    callback (key) {
      /* const refName = 'bt' + this.baseKey
       let isChangeText = this.$refs[refName].getIsChangeText()
      if (isChangeText) {
        this.$message.error('该模块内容尚未保存，请确认是否保存')
        this.baseKey = this.baseKey
      } */
    },
    /* handleTabClick (key) {
      console.log('handleTabClick', key)
      console.log('this.baseKey', this.baseKey)
      const refName = 'bt' + this.baseKey
      console.log('refName', refName)
      if (this.baseKey > 0 && this.baseKey < 6) {
        console.log('this.$refs[refName]', this.$refs[refName])
        let isChangeText = this.$refs[refName].getIsChangeText()
        if (isChangeText) {
          this.$message.error('该模块内容尚未保存，请确认是否保存')
          this.baseKey = this.baseKey
        } else {
          this.baseKey = key
        }
      } else {
        this.baseKey = key
      }
    }, */
    tabCallback (key) {
      // console.log('on tab change:', key)
      if (typeof key !== 'undefined') {
        if (key === '888') { // ai自查接口 废弃
          this.loadingCheck = true
          try {
            let activityKeyNumber = 7
            this.$api.checkSelfBase(activityKeyNumber, '').then(res => {
              if (res && res.status === 200) {
                const resData = res.data.data
                console.log('resData.tips', resData.tips)
                this.checkBaseResult = resData.tips
                this.checkBaseScore = resData.score
                this.loadingBaseFeedback = false
              }
              this.loadingCheck = false
            }).catch(error => {
              this.loadingCheck = false
              this.loadingBaseFeedback = false
              if (typeof error.data !== 'undefined') {
                let res = error.data
                this.$message.error(res.msg || '自查失败，请稍后重试')
              } else {
                this.$message.error('自查失败，请稍后重试')
              }
              console.log('error', error)
            })
          } catch (error) {
            this.loadingCheck = false
            console.log('activityKeyNumber translate error', error)
          }
        }
      }
    },
    getArticle () {
      // 获取知识库的接口
      if (!this.$store.state.userAuth.haveLogin) {
        return
      }
      if (typeof this.$store.state.project0.id === 'undefined') {
        this.$message.error('项目id为空 请重试')
        return
      }
      this.loadingBase = true
      this.$api.getArticle2(this.$store.state.project0.id).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          // 默认项目的知识库
          if (Array.isArray(resData)) {
            if (resData.length > 0) {
              // resData[0].sale_service_json = {'score': 0, 'text': ''}
              this.baseContentJson = resData[0]
            }
          }
        }
        this.loadingBase = false
      }).catch(error => {
        if (typeof error.data !== 'undefined') {
          let res = error.data
          if (res.msg === 'Token has expired') {
            this.$message.error('登录有效性过期，请退出后重新登录') // 获取云端知识库失败，请重试
          } else {
            this.$message.error('获取云端知识库失败，请重试')
          }
        } else {
          this.$message.error('获取云端知识库失败，请重新登录')
        }
        console.log('error', error)
        this.loadingBase = false
      })
    },
    handleFileChange (info) {
      // 文件状态改变的回调 上传中、完成、失败都会调用这个函数
      console.log('handleFileChange info :', info) // 包含了file 和 fileList
      console.log('handleFileChange fileList:', info.fileList)
      /* if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      } */

      let fileList = [...info.fileList]

      // 1. Limit the number of uploaded files
      //    Only to show two recent uploaded files, and old ones will be replaced by the new
      fileList = fileList.slice(-1)

      // 2. read from response and show file link
      /* fileList = fileList.map(file => {
        if (file.response) {
          // Component will show file.url as link
          file.url = file.response.url
        }
        return file
      }) */

      this.fileList = fileList
    },
    handleBeforeUpload (file) {
      // 预览文件内容
      console.log('file:', file)
      if (file.type === 'text/plain') {
        if (file.size / 1024 < 300) {
          const reader = new FileReader()
          reader.onload = (e) => {
            /* console.log('e', e)
            console.log('target result', e.target.result) */

            this.fileContent = e.target.result
          }
          reader.readAsText(file, 'UTF-8')
        } else {
          this.$message.error('现在内容十万字，文件大小不能超过300K！')
          return false // 阻止文件上传
        }
      } else {
        this.$message.error('请选择一个文本格式的文件！')
        return false // 阻止文件上传
      }
    },
    handleBeforeUploadImage (file) {
      // 预览文件内容
      console.log('image file:', file)
      if (file.size / 1024 / 1024 < 2) {
        return true
      } else {
        return false // 阻止文件上传
      }
    },
    showLoginPanel () {
      if (this.$store.state.isMeuHost) {
        this.$message.error('暂不支持')
      } else {
        this.showLogin()
      }
    },
    getRowKey (record, index) {
      return index // 使用索引作为行的唯一标识
    },
    renderIndex (text, record, index) {
      return index + 1 // 显示序号，从1开始
    },
    renderDescription (text) {
      if (text.length > 15) {
        return `${text.slice(0, 15)}...` // 使用省略号替代超过30个字符的部分
      }
      return text
    },
    customUpload (options) {
      console.log('options:', options)
    },
    updateArticle () {
      let params = {}
      this.$api.updateArticle(params).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          console.log('知识库更新结果', resData)
        }
      }).catch(error => {
        if (typeof error.data !== 'undefined') {
          let res = error.data
          this.$message.error(res.msg)
        }
        console.log('error', error)
      })
    },
    uploadFileBefore () {
      this.openBaseSubmitDialog = true
    },
    uploadFile () {
      // 创建一个 Blob 对象，将文本内容转换为文件
      const blob = new Blob([this.fileContent], { type: 'text/plain' })
      const fileItem = new File([blob], 'upload.txt', { type: 'text/plain' })
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined' || this.$store.state.project0.id === -1) {
        this.$message.error('请重新登录')
        return
      }
      axios.post(store.state.apiHost + '/api/article/upload/' + this.$store.state.project0.id, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // console.log('上传成功 response', response)
        if (response.status === 200) {
          console.log('上传成功')
          this.$message.success(response.msg || '上传成功')
          this.fileList[0].status = 'done'
        }
      }).catch(error => {
        // this.$message.error('文件上传失败请重试' + errorMsg)

        // 处理错误的响应
        if (error.response) {
          // 请求已发送，服务器返回了非2xx状态码
          console.log('error.response:', error.response.data)
          this.$message.error(error.response.data.msg)
          // console.log(error.response.status)
          // console.log(error.response.headers)
        } else if (error.request) {
          // 请求已发送但没有收到响应
          console.log('error.request:', error.request)
        } else {
          // 其他错误
          console.log('Error', error.message)
        }
        console.log('Error config：', error.config)
      })
    },
    uploadFileCopy () {
      if (this.fileList.length < 1) {
        this.$message.error('尚未选择文件')
        return
      }
      let fileItem = this.fileList[0].originFileObj
      console.log('fileItem.name：', fileItem.name)
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined' || this.$store.state.project0.id === -1) {
        this.$message.error('请重新登录')
        return
      }
      axios.post(store.state.apiHost + '/api/article/upload/' + this.$store.state.project0.id, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功')
          this.$message.success('上传成功')
          this.fileList[0].status = 'done'
        }
      }).catch(error => {
        console.log('error', error)
        let errorMsg = ''
        if (error && error.msg) {
          errorMsg = error.msg
        }
        this.$message.error('上传失败请重试' + errorMsg)
      })
    },
    selectAllProduct () {
      console.log('enter selectAllProduct', this.$store.state.userAuth)
      let userAuth = this.$store.state.userAuth
      let project0 = this.$store.state.project0
      let phone = userAuth.username
      let projectId = project0.id
      console.log('send phone :' + phone)
      console.log('send projectId :' + projectId)
      if (projectId > -1) {
        this.$api.getProductList(phone, projectId).then(res => {
          if (res.status === 200) {
            const data = res.data.data
            // 排序
            if (data.length > 0) {
              this.testList = data.sort((a, b) => b.id - a.id)
            }
          }
        }).catch(error => {
          console.log('query AllProduct error:', error)
        })
      } else {
        console.log('*** not do getProductList')
      }
    },
    queryProduct () {
      console.log('this.productName:', this.productName)
      if (this.productName === '') {
        this.selectAllProduct()
      } else {
        this.testList = this.testList.filter(t => {
          return t.name.includes(this.productName)
        })
      }
    },
    queryReset () {
      this.productName = ''
      this.selectAllProduct()
    },
    deleteList () {
      /* if (this.selectedList.length === 0) {
        this.$message.error('您没有勾选数据')
      } else {
        this.$message.

      } */
    },
    deleteListSure () {
      if (this.selectedList.length === 0) {
        this.$message.error('您没有勾选数据')
      } else {
        for (let i = 0; i < this.selectedList.length; i++) {
          this.onDelete(this.selectedList[i])
        }
      }
    },
    onDelete (data) {
      if (data.id === '' || typeof data.id === 'undefined' || data.id < 0) {
        console.log('商品id无效，请刷新重试')
        this.$message.error('商品id无效，请刷新重试')
        console.log('data', data)
        return
      }
      this.$api.deleteProduct(data.id).then(res => {
        if (res.status === 200 || res.status === 'ok') {
          this.$message.success('删除商品成功')
          this.selectAllProduct() // 重新查询产品
        }
      }).catch(error => {
        this.$message.success('删除失败，请刷新重试')
        console.log('error', error)
      })
    },
    clearList () {
      this.testList = []
      this.fileList = []
      this.imageList = []
    },
    onEdit (data) {
      // console.log('onEdit', data)
      if (!this.$store.state.userAuth.haveLogin) {
        this.$message.error('尚未登录')
        this.clearList()
        return
      }
      this.initWarnInfo()
      this.productItem = data
      this.productItem.cover = data.cover_url
      this.productItem.cover_urls = data.cover_urls
      this.productItem.project_id = data.project
      this.productItem.text = data.comm_tip
      this.productItem.commodity_id = data.id
      this.previewImageSrc = data.cover_url

      // 构建cover_urls的数据进行适配组件
      this.imageList = []
      for (let i = 0; i < this.productItem.cover_urls.length; i++) {
        let imageListItem = {
          uid: i + '',
          name: 'image' + i + '.png',
          status: 'done',
          url: this.productItem.cover_urls[i]
        }
        this.imageList.push(imageListItem)
      }
      // 构建视频字段
      this.videoList = []
      if (data.video_urls.length > 0) {
        let videoItem = {
          uid: 1,
          name: 'video.mp4',
          status: 'done',
          url: data.video_urls[0]
        }
        this.videoList.push(videoItem)
      }
      this.modalVisible = true
      this.submitType = 2
    },
    checkSelfPD (productItem) {
      let fullStr = '商品名称：' + productItem.name + '。商品说明：' + productItem.description
      if (typeof productItem.price === 'undefined' || productItem.price === '') {
        fullStr += '。价格面谈'
      } else {
        fullStr += ('。价格' + productItem.price)
      }

      if (typeof productItem.url === 'undefined' || productItem.url === '') {
        fullStr += ('。链接' + productItem.url)
      }
      this.checkPDResult = ''
      this.checkPDDialogVisible = true
      this.loadingPDFeedback = true
      this.$api.checkSelfBase(6, fullStr).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (typeof resData.tips !== 'undefined') {
            this.checkPDResult = resData.tips
          } else {
            this.$message.error(res.msg || '自查失败，请稍后重试')
          }
          this.loadingPDFeedback = false
        }
      }).catch(error => {
        this.loadingPDFeedback = false
        if (typeof error.data !== 'undefined') {
          let res = error.data
          this.$message.error(res.msg || '自查失败，请稍后重试')
        } else {
          this.$message.error('自查失败，请稍后重试')
        }
        console.log('error', error)
      })
    },
    addProduct () {
      if (!this.$store.state.userAuth.haveLogin) {
        this.$message.error('尚未登录')
        this.testList = []
        this.fileList = []
        this.imageList = []
        this.videoList = []
        return
      }
      this.modalVisible = true
      this.submitType = 1
      this.productItem = JSON.parse(JSON.stringify(this.productTemplate))
      this.imageList = []
      this.videoList = []
      this.initWarnInfo()
    },
    initWarnInfo () {
      this.warnInfo.showName = false
      this.warnInfo.showPrice = false
      this.warnInfo.showImage = false
      this.warnInfo.showCommTip = false
      this.warnInfo.showDescription = false
    },
    checkWarnInfo (item) {
      let canUse = true
      if (this.productItem.name === '') {
        this.warnInfo.showName = true
        this.warnInfo.showNameMsg = '请输入产品名称'
        canUse = false
      } else {
        // 校验长度小于16位 中英文 不包含特殊字符
        // eslint-disable-next-line no-inner-declarations
        const validateString = str => {
          // 使用正则表达式进行校验
          const pattern = /^[\u4e00-\u9fa5a-zA-Z0-9]{1,32}$/
          return pattern.test(str)
        }
        const isValid = validateString(this.productItem.name)
        if (!isValid) {
          canUse = false
          this.warnInfo.showName = true
          this.warnInfo.showNameMsg = '产品名称需要小于16位的中英文，但不能包含特殊字符'
        } else {
          this.warnInfo.showName = false
        }
      }
      if (this.productItem.price === '') {
        this.warnInfo.showPrice = true
        this.warnInfo.showNameMsg = '请输入产品价格'
        canUse = false
      } else {
        const validatePrice = str => {
          // 使用正则表达式进行校验
          const pattern = /^\d+(\.\d{1,2})?$/
          return pattern.test(str)
        }
        const isValid = validatePrice(this.productItem.price)
        console.log('validatePrice:', isValid)
        if (!isValid) {
          canUse = false
          this.warnInfo.showPrice = true
          this.warnInfo.showPriceMsg = '产品价格的格式错误，最多保留两位小数'
        } else {
          this.warnInfo.showPrice = false
        }
      }
      if (this.productItem.description === '') {
        this.warnInfo.showDescription = true
        canUse = false
      }
      if (this.productItem.comm_tip === '') {
        this.warnInfo.showCommTip = true
        canUse = false
      }
      if (item.cover_urls.length < 1) {
        this.warnInfo.showImage = true
        canUse = false
      }
      return canUse
    },
    // 保存产品
    handleOk () {
      // 验证各个输入框值：必填和格式 错误则进行提示
      console.log('handleOk this.productItem:' + new Date(), this.productItem)
      let item = this.productItem
      item.headers = {Authorization: this.$store.state.userAuth.userToken, 'Content-Type': 'application/json'}
      item.request_type = this.submitType // 1 新增 2更新
      item.text = item.comm_tip
      item.project = this.$store.state.project0.id
      item.project_id = this.$store.state.project0.id
      item.cover_url = ''
      item.cover_urls = []
      this.imageList.forEach(t => {
        if (t.status === 'done' && t.url !== '') {
          item.cover_urls.push(t.url)
        }
      })
      if (this.imageList.length > 0 && this.imageList[0].url !== '') {
        item.cover_url = this.imageList[0].url
      }
      console.log('handleOk item:', item)
      let canUse = this.checkWarnInfo(item)
      if (!canUse) {
        return
      }
      this.confirmLoading = true
      this.$api.addProduct(item).then(res => {
        // console.log('addProduct res:', res)
        if (res.status === 200) {
          this.$message.success('您的数据已在聊天中更新。')
          /* if (this.submitType === 1) {
            this.$message.success('添加产品成功')
          } else {
            this.$message.success('更新产品成功')
          } */
          this.confirmLoading = false
          this.modalVisible = false
          this.selectAllProduct()
        }
      }).catch(error => {
        console.log('error', error)
        this.confirmLoading = false
        this.$message.error('保存失败请重试')
      })
    },
    handleCancel (e) {
      this.modalVisible = false
    },
    showServiceGuide () {
      this.showServiceGuideModal = true
    },
    downloadBaseTemplate2 () {
      // const downloadLink = 'https://test.aigcpop.com/agent_file/article_example.txt'
      /* axios({
        url: downloadLink,
        method: 'get',
        responseType: 'blob'
      }).then(res => {
        let blob = new Blob([res.data], {type: res.headers['content-type']})
        // 创建新的URL并指向File对象或者Blob对象的地址
        const blobURL = window.URL.createObjectURL(blob)
        // 创建a标签，用于跳转至下载链接
        const tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
        const contentDisposition = res.headers['content-disposition']
        tempLink.setAttribute('download', decodeURI(contentDisposition.split(';')[1].split('=')[1]))
        // 兼容：某些浏览器不支持HTML5的download属性
        if (typeof tempLink.download === 'undefined') {
          tempLink.setAttribute('target', '_blank')
        }
        // 挂载a标签
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        // 释放blob URL地址
        window.URL.revokeObjectURL(blobURL)
      }) */
    },
    downloadBaseTemplate () {
      const textToWrite = '123'
      const textFileAsBlob = new Blob([textToWrite], { type: 'text/plain' })
      const fileNameToSaveAs = 'file.txt'

      const downloadLink = document.createElement('a')
      downloadLink.download = fileNameToSaveAs
      downloadLink.innerHTML = 'Download File'

      if (window.webkitURL != null) {
        // Chrome allows the link to be clicked
        // without actually adding it to the DOM.
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob)
      } else {
        // Firefox requires the link to be added to the DOM
        // before it can be clicked.
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
        downloadLink.onclick = function (event) {
          document.body.removeChild(event.target)
        }
        downloadLink.style.display = 'none'
        document.body.appendChild(downloadLink)
      }

      downloadLink.click()
    },
    handleImageCancel (e) {
      this.previewVisible = false
    },
    handleVideoCancel (e) {
      this.$refs.pdVideo.pause()
      this.productPlaying = false
      this.previewVisibleVideo = false
    },
    handleImageChange ({ fileList }) {
      if (fileList.length > 0) {
        if (fileList[fileList.length - 1].size / 1024 / 1024 > 2) {
          this.$message.error('上传图片大小不能超过2M！')
          /* fileList = []
          this.imageList = [] */
        } else {
          this.imageList = fileList
        }
      } else {
        this.imageList = fileList
      }
    },
    async getBase64 (file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      })
    },
    async handlePreview (file) {
      console.log('handlePreview file:', file)
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      }
      this.previewImageSrc = file.url || file.preview
      this.previewVisible = true
    },
    async handlePreviewVideo (file) {
      /* if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj)
      } */
      this.previewVideoSrc = file.url || file.preview
      this.previewVisibleVideo = true
    },
    handleCustomRequest (options) {
      // 上传产品图片
      // 创建一个 FormData 对象
      console.log('handleCustomRequest', options)
      let fileItem = options.file
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined') {
        this.$message.error('请重新登录')
        return
      }
      axios.post(this.imageUploadAction, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功', response.data.data.url)
          this.$message.success('图片上传成功')
          const resultUrl = response.data.data.url
          this.imageList[this.imageList.length - 1].status = 'done'
          this.imageList[this.imageList.length - 1].url = resultUrl
        }
      }).catch(error => {
        console.log('error', error)
        let errorMsg = ''
        if (error && error.msg) {
          errorMsg = error.msg
        }
        this.clearList()
        this.$message.error('上传失败请重试' + errorMsg)
      })
    },
    handleBeforeUploadVideo (file) {
      if (file.size / 1024 / 1024 < 25) {
        return true
      } else {
        return false // 阻止文件上传
      }
    },
    handleVideoChange ({ fileList }) {
      console.log('enter handleVideoChange')
      if (fileList.length > 0) {
        if (fileList[fileList.length - 1].size / 1024 / 1024 > 25) {
          this.$message.error('上传视频大小不能超过30M！')
          fileList = []
          this.videoList = []
        } else {
          this.videoList = fileList
        }
      } else {
        this.videoList = fileList
      }
    },
    playPdVideo () {
      if (this.productPlaying) {
        this.$refs.pdVideo.pause()
        this.productPlaying = !this.productPlaying
      } else {
        setTimeout(() => {
          this.$refs.pdVideo.play()
        }, 200)
      }
    },
    onPDVideoPlaying () {
      this.productPlaying = true
    },
    setVideoSize () {
      const video = this.$refs.pdVideo
      const container = this.$refs.videoContainer
      if (video.videoWidth && video.videoHeight) {
        const videoAspectRatio = video.videoWidth / video.videoHeight
        const containerWidth = container.offsetWidth
        const containerHeight = containerWidth / videoAspectRatio
        container.style.height = `${containerHeight}px`
      }
    },
    handleCustomRequestVideo (options) {
      // 上传产品视频
      // 创建一个 FormData 对象
      console.log('handleCustomRequest', options)
      let fileItem = options.file
      const formData = new FormData()
      formData.append('file', fileItem, fileItem.name)
      formData.append('name', fileItem)
      let token = this.$store.state.userAuth.userToken
      if (token === '' || typeof token === 'undefined') {
        this.$message.error('请重新登录')
        return
      }
      axios.post(this.videoUploadAction, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        // console.log('response', response)
        if (response.status === 200) {
          console.log('上传成功', response.data.data.url)
          this.$message.success('视频上传成功')
          const resultUrl = response.data.data.url
          this.videoList[this.videoList.length - 1].status = 'done'
          this.videoList[this.videoList.length - 1].url = resultUrl
        }
      }).catch(error => {
        console.log('error', error)
        let errorMsg = ''
        if (error && error.msg) {
          errorMsg = error.msg
        }
        this.clearList()
        this.$message.error('视频上传失败请重试' + errorMsg)
      })
    },
    // UI工具
    handleKeyDown (event) {
      // 检测是否按下了 Ctrl 键（event.ctrlKey）和 S 键（event.key === 's'）
      if ((event.ctrlKey && event.key === 's') || (event.metaKey && event.keyCode === 83)) {
        // 阻止默认行为，避免浏览器执行保存操作
        if (this.baseKey !== '0') {
          event.preventDefault()
          this.saveBase()
        }
      }
    },
    dialogSave () {
      this.isShowChangeTextDialog = false
      const refName = 'bt' + this.baseKey
      this.$refs[refName].setIsChangeText()
      this.saveBase()
    },
    textChangeDialogCancel () {
      this.isShowChangeTextDialog = false
      // 改变对于textarea组件的change状态
      /* const refName = 'bt' + this.baseKey
      this.$refs[refName].setIsChangeText() */
      this.baseKey = this.wantTabKey
    },
    // 业务逻辑
    checkSelfBase () {
      console.log('checkSelfBase执行1次', new Date())
      const refName = 'bt' + this.baseKey
      this.$refs[refName].checkSelfBase()
    },
    saveBase () {
      console.log('saveBase执行1次', new Date())
      const refName = 'bt' + this.baseKey
      this.$refs[refName].saveBase()
    },
    jieCheckSelfBase: _.debounce(function () {
      this.checkSelfBase()
    }, 1000),
    jieSaveBase: _.debounce(function () {
      this.saveBase()
    }, 1000),
    jieHandleOk: _.debounce(function () {
      this.handleOk()
    }, 1000),
    refreshFullContent () {
      if (!this.$store.state.userAuth.haveLogin) {
        this.$message.error('尚未登录，请先点击右上角登录后再试')
        return
      }
      this.loadingCheck = true
      let contentType = 17
      let params = {
        content_type: contentType
        // text: this.baseContent.text
      }
      this.$api.contentFromAi(params).then(res => {
        if (res && res.status === 200) {
          const resData = res.data.data
          if (resData.info !== '') {
            this.fileContentFull = resData.info
            localStorage.setItem('fileContentFull', JSON.stringify(resData.info))
            this.loadingCheck = false
          }
        }
      }).catch(error => {
        this.loadingCheck = false
        if (typeof error.data !== 'undefined') {
          let res = error.data
          this.$message.error(res.msg || 'AI生成失败，请稍后重试')
        } else {
          this.$message.error('AI生成失败，请稍后重试')
        }
        console.log('error', error)
      })
    }
  }
}
</script>

<style lang="less">
.ant-upload-list-item:hover .ant-upload-list-item-info{
  background: none !important;
}
// 加载知识库的加载框
.loadingBaseClass{
  .ant-spin-dot-item{
    background: #28e04a;
  }
}
// 复选框选择背景颜色
.ant-checkbox-checked .ant-checkbox-inner{
  background: #28e04a !important;
  border-color: #28e04a !important;
}
.ant-checkbox:hover .ant-checkbox-input:hover{
  background: #28e04a !important;
  border-color: #28e04a !important;
}
// 复选框 标题框
.ant-checkbox-indeterminate .ant-checkbox-inner::after{
  background: #28e04a !important;
}

.ant-table-tbody > tr.ant-table-row-selected td{
  background: none !important;// 复选框选择背景颜色
}
.ant-tabs-tab {
  color: white;
}
.ant-tabs-tab{
  text-align: left !important;
}
.ant-tabs-tab-prev{
  color: white;
}
.ant-tabs-tab-next{
  color: white;
}
.ant-tabs-nav .ant-tabs-tab-active{
  color: #28E04A !important;
}
.ant-tabs-nav:hover .ant-tabs-tab-active:hover{
  color: #28E04A !important;
}
.ant-tabs-nav .ant-tabs-tab:hover {
  color: white !important;
}
.ant-tabs-ink-bar{
  display: none !important;
  background-color: #28E04A;
}
.ant-tabs-content{
  min-height: 550px;
}
.ant-upload-list-item-info{
  color: white;
}
.ant-upload-list-item-info .anticon-loading, .ant-upload-list-item-info .anticon-paper-clip {
  color: white;
}
.ant-table-thead > tr > th {
  height: 40px !important;
  background: rgba(255,255,255,0.2) !important; // 标题背景颜色
  color: white !important;
  font-size: 16px !important;
  line-height: 16px !important;
  padding: 8px !important;
}
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row) > td,.ant-table-row-hover,.ant-table-row-hover>td{
  background: rgb(90, 94, 104) !important;
}

.ant-table-fixed .ant-table-row-hover,.ant-table-row-hover>td{
  background: rgb(90, 94, 104) !important;
}
.ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
  background: rgb(90, 94, 104) !important; // 设置高亮 rgb(90, 94, 104);
}
.ant-table-placeholder{
  background: rgba(255,255,255,0.2) !important; // 没有数据的背景颜色
  color: white !important;
}
/*.ant-table-row-level-0:hover{
  background: red !important; // 会一闪即逝
}*/

.ant-table-tbody > tr > td{
  padding: 8px !important;
}
.ant-table-tbody{
  color: white !important;
}
.custom_tab {
  .ant-tabs-left-content {
    border: 0 !important;
  }
  .hide-divider .ant-tabs-tab {
    border: none !important;
  }
  .ant-tabs-bar .ant-tabs-left-bar{
    border-right: 0 !important;
  }
}

.custom_base_tab {
  .ant-tabs-left-content {
    border: 0 !important;
  }
  .hide-divider .ant-tabs-tab {
    border: none !important;
  }
  .ant-tabs-bar{
    border-bottom: 0 !important;
  }
  .ant-tabs-bar .ant-tabs-left-bar{
    border-right: 0 !important;
    border-bottom: 0 !important;
  }
  .ant-tabs-content{
    min-height: 0;
  }
  /*tab标签页的title div*/
  .ant-tabs-tab{
    padding: 0;
    margin: 12px 48px 12px 16px;
  }
}

.product_modal_row{
  .input_project_custom{
    /*width: 351px !important;
    height: 27px !important;*/
    margin-top: 5px;
    margin-bottom: 5px;
    color: black !important; // #999999
    font-weight: 600;
    text-align: left !important;
  }
  .errorInputText{
    font-size: 12px;
    font-weight: 400;
    color: #FF1D1D;
    line-height: 14px;
    margin-bottom: 10px;
  }
}
.base_submit_dialog{
  .ant-btn-primary {
    background: rgb(17, 159, 250) !important;
    border-color:rgb(17, 159, 250) !important;
  }
  .base_submit_dialog_content{
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #000000;
    line-height: 23px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-top: 20px;
  }
}

.ant-btn-primary {
  background: #28e04a;
  border-color: #28e04a;
}
.productModal{
  .ant-modal-body{
    padding: 20px 48px 0 48px !important;
  }
}
</style>
<style lang="less" scoped>
  .project_name{
    display: inline-block;
    color: white;
    font-size: 18px;
    font-weight: 300;
    line-height: 16px;
    text-align: left;
  }
  .project_item{
    margin-right: 25px;
    text-align: center;
  }
  .btn_query_project{
    width: 77px;
    height: 35px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 18px;
    background: #28E04A;
    border-color: #28E04A;
  }
  .btn_query_project:hover{
    background: rgb(60, 244, 94);
  }
  .custom_tab_panel_title{
    // color: white;
    text-align: right;
    font-size: 20px;
    .tab_title_mini{
      margin-left: 22px;
      font-size: 16px;
    }
  }
  .headerRow{
    font-size: 18px;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 16px;
    text-align: left;
    padding: 15px 0 0 0;
    margin-bottom: 20px;
  }
  .btn_add_project{
    width: 130px;
    height: 35px;
    border-radius: 4px;
    font-weight: 400;
    font-size: 18px;
    background: #28E04A;
    border-color: #28E04A;
  }
  .btn_add_project:hover{
    background: rgb(60, 244, 94);
  }
  .custom_tab{
    padding-left: 100px;
    padding-right: 135px;
    .ant-tabs-left-content{
      border: 0;
    }
    .hide-divider .ant-tabs-tab {
      border: none;
    }
    .serviceInfoManage{
      font-size: 20px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 23px;
      background-color: #313642;
      padding: 0 38px 10px 38px;
      border-radius: 4px;
      min-height: 550px;
      .btn_upload{
        width: 120px;
        height: 40px;
        font-size: 16px;
        font-weight: 400;
      }
      /deep/ .btn_upload:hover{
        color: black;
        border: 0;
      }
      /deep/ .btn_now{
        height: 40px;
        font-weight: 400;
        background: #28E04A;
        border-radius: 4px 4px 4px 4px;
        border-color: #28E04A;
        opacity: 1;
        font-size: 16px;
        color: #000c17;
      }
      /deep/ .btn_save{
        width: 120px;
        height: 40px;
        font-weight: 400;
        background: #28E04A;
        border-radius: 4px 4px 4px 4px;
        border-color: #28E04A;
        opacity: 1;
        font-size: 16px;
        color: #000c17;
      }
      .bg_gray{
        background: rgb(22, 91, 68) !important;
        border: rgb(22, 91, 68) !important;
      }
      .bgLessWhite{
        background: rgb(128, 158, 160) !important;
        border: rgb(128, 158, 160) !important;
      }
      .serviceInfoManageTitle{
        font-size: 22px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 33px;
        padding: 18px 0 15px 0;
        text-align: center;
        background-color: #313642;
      }
    }
    .productManage{
      font-size: 20px;
      font-weight: 400;
      color: rgba(255,255,255,0.8);
      line-height: 23px;
      background-color: #313642;
      padding: 0 38px 10px 38px;
      border-radius: 4px;
      min-height: 550px;
      .headerRow{
        font-size: 18px;
        font-weight: 300;
        color: #FFFFFF;
        line-height: 16px;
        text-align: left;
        background-color: #313642;
        padding: 15px 0 0 0;
        margin-bottom: 20px;
        .input_project_custom{
          width: 178px !important;
          height: 35px !important;
          text-align: left !important;
        }
      }
      .project_item{
        margin-right: 25px;
      }
      /*.project_item:hover{
        background: rgb(60, 244, 94);
        color: #000c17;
      }*/
      .project_name{
        display: inline-block;
        color: white;
      }
      .btn_reset_project{
        width: 77px;
        height: 35px;
        border-radius: 4px;
        opacity: 1;
        font-weight: 400;
        font-size: 18px;
      }
      .btn_add_project{
        width: 130px;
        height: 35px;
        border-radius: 4px;
        font-weight: 400;
        font-size: 18px;
        background: #28E04A;
        border-color: #28E04A;
      }
      .btn_add_project:hover{
        background: rgb(60, 244, 94);
      }
      .product_table{
        .product_option{
          color: #28E04A;
          font-size: 14px;
          font-weight: 400;
          color: #28E04A;
          line-height: 14px;
        }
      }

    }
  }
  .product_modal_title_row{
    font-size: 16px;
    font-weight: 500;
    color: black;
    .warnInfo{
      color: red;
    }
  }
  .serviceGuideModal{
    ant-modal-body{
      padding-bottom: 10px;
    }
  }
  .title_h2{
    font-weight: 600;
    margin-top: 20px;

  }
  .title_h3{
    line-height: 1.5; /* 设置行高为文字大小的1.5倍 */
  }

</style>
<style lang="less">
.myResult{
  .ant-result-title{
    color: whitesmoke;
  }
  .ant-btn-primary:hover{
    background-color: #28e04a !important;
    border-color: #28e04a !important;
  }
  .ant-btn-primary:active{
    background-color: #28e04a !important;
    border-color: #28e04a !important;
  }
  .ant-btn-primary:focus{
    background-color: #28e04a !important;
    border-color: #28e04a !important;
  }
}

</style>
<style lang="less">
.custom_textarea{
  background: none !important;
  border-color: rgba(153,153,153,0.5);
  color: rgba(255,255,255,0.8) !important;
  margin-bottom: 10px;
  scrollbar-width: thin;
  scrollbar-color: #999999 #f5f5f5;
  padding: 16px;
}
.custom_tab{
  .ant-tabs-tab{
    margin-bottom: 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Base.vue